export class ProcessBuilderTO {
    id: number;
    formId: number;
    model: string;
    workingOutputModel: string;
    activityDate: Date;
}
